import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  return <header className="sticky top-0 z-50 bg-white shadow-sm" data-id="element-133">
      <div className="container mx-auto px-4 py-3 md:py-4 max-w-7xl" data-id="element-134">
        <div className="flex justify-between items-center" data-id="element-135">
          <div className="flex items-center" data-id="element-136">
            <a href="/" className="flex items-center" data-id="element-137">
              <img src="https://cdn.magicpatterns.com/uploads/e5BUmyxLnn3e5mAPwSBoue/Recruitmenttest_logo_website.png" alt="Recruitment Test for Laravel" className="h-12 md:h-[60px]" data-id="element-138" />
            </a>
          </div>
          <div className="hidden md:flex space-x-8" data-id="element-139">
            <a href="#how-it-works" className="text-gray-700 hover:text-primary transition-colors font-medium" data-id="element-140">
              How It Works
            </a>
            <a href="#why-choose" className="text-gray-700 hover:text-primary transition-colors font-medium" data-id="element-141">
              Features
            </a>
            <a href="#pricing" className="text-gray-700 hover:text-primary transition-colors font-medium" data-id="element-142">
              Pricing
            </a>
            <a href="#what-we-test" className="text-gray-700 hover:text-primary transition-colors font-medium" data-id="element-143">
              What We Test
            </a>
          </div>
          <div className="hidden md:flex space-x-4" data-id="element-144">
            <a href="https://certificationforlaravel.testportal.com/test.html?t=Xj7qVzGX8p3c" className="px-5 py-2 text-primary border border-primary rounded-2xl hover:bg-primary/5 transition-colors font-medium" data-id="element-145">
              Try a Sample Test
            </a>
            <a href="#pricing" className="px-5 py-2 bg-primary text-white rounded-2xl hover:bg-primary/90 transition-colors font-medium" data-id="element-146">
              Buy Tests
            </a>
          </div>
          <div className="md:hidden" data-id="element-147">
            <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="p-2 text-gray-600 hover:text-primary" aria-label="Toggle menu" data-id="element-148">
              {isMenuOpen ? <X size={24} data-id="element-149" /> : <Menu size={24} data-id="element-150" />}
            </button>
          </div>
        </div>
        {isMenuOpen && <div className="md:hidden py-4 space-y-1 border-t border-gray-100 mt-3" data-id="element-151">
            <a href="#how-it-works" className="block py-3 px-2 text-gray-700 hover:text-primary hover:bg-gray-50 rounded-lg transition-colors font-medium" onClick={() => setIsMenuOpen(false)} data-id="element-152">
              How It Works
            </a>
            <a href="#why-choose" className="block py-3 px-2 text-gray-700 hover:text-primary hover:bg-gray-50 rounded-lg transition-colors font-medium" onClick={() => setIsMenuOpen(false)} data-id="element-153">
              Features
            </a>
            <a href="#pricing" className="block py-3 px-2 text-gray-700 hover:text-primary hover:bg-gray-50 rounded-lg transition-colors font-medium" onClick={() => setIsMenuOpen(false)} data-id="element-154">
              Pricing
            </a>
            <a href="#what-we-test" className="block py-3 px-2 text-gray-700 hover:text-primary hover:bg-gray-50 rounded-lg transition-colors font-medium" onClick={() => setIsMenuOpen(false)} data-id="element-155">
              What We Test
            </a>
            <div className="flex flex-col space-y-3 pt-4" data-id="element-156">
              <a href="https://certificationforlaravel.testportal.com/test.html?t=Xj7qVzGX8p3c" className="px-5 py-3 text-center text-primary border border-primary rounded-2xl hover:bg-primary/5 transition-colors font-medium" data-id="element-157">
                Try a Sample Test
              </a>
              <a href="#pricing" className="px-5 py-3 text-center bg-primary text-white rounded-2xl hover:bg-primary/90 transition-colors font-medium" data-id="element-158">
                Buy Tests
              </a>
            </div>
          </div>}
      </div>
    </header>;
}